import { FeatureFlags } from './featureFlags.type';

export const useFeatureFlags = (): FeatureFlags => {
  return { isReady: true };
};
